const SCROLL_TO_COMPONENT_PARAMS = {
  offset: -100,
  align: 'top',
  duration: 100
};

export default SCROLL_TO_COMPONENT_PARAMS;
